module.exports = __webpack_public_path__ + "img/savings-compare.4354de6.webp";